import Vue from 'vue'
import Vuex from 'vuex'

// 子模块
import Cang from './modules/Cang'

import { GetAllAreas } from '../components/Request'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {

		// 项目ID(直接配置)
		projectId:15,

		// influxDbName(在app.vue中通过接口获取)
		db: '',

		// 项目GIS地址(在App.vue中通过接口获取)
		gisUrl: null,

		// 变压器容量和供电电压(在home里面通过接口获取)
		receivingCapacity: 0,
		voltageClass: 0,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            

		// 变压器数量(在home里面通过接口获取)
		transformerNum: 0,  

		// 监控和门禁列表(在home中获取)
		surveillance: [],
		nav:'',

		// 根据区域获取threejs地址(在home中通过接口获取)
		allThreeUrl: [
		],

		// MQTT数据(在APP.Vue中通过mqtt获取)
		MQTTObj: {},

		// 主进线回路(在home中通过接口获取)
		loopMaster: [0],

		// 项目和区域的负荷率(在home中通过接口获取)
		load: [],
		currentPage:1,
		// 首页的用电分布按钮开关
		electricityFlag:true,
		siteId:'',
		// 首页是否显示当前的报警信息
		showAlarm:false,
		// 当前项目的所有区域
		areas:[]
	},
	mutations: {
		addMQTTData(state, obj) {
			Vue.set(state.MQTTObj, obj.key, obj.val)
		},
		set_val(state, object) {
			for (let key in object) {
				state[key] = object[key]
			}
		},
		del_val(state, val) {
			state.val = ''
		},
		set_page(state,page){
			state.currentPage = page
			console.log(page);
		},
		set_electricityFlag(state,flag){
			state.electricityFlag = flag
		},
		set_siteId(state,id){
			state.siteId = id
		},
		set_showAlarm(state,flag){
			state.showAlarm = flag
		},
		// 异步调用改变state中的areas
		getAreas(state,areas){
			state.areas = areas
			// console.log(areas);
		},
		set_nav(state, nav){
			state.nav = nav
		}
	},
	getters: {
		unbalance: state => deviceName => {

			let ua = isNaN(Number.parseFloat(state.MQTTObj[deviceName + '/Ua'])) ? 0 : Number.parseFloat(state.MQTTObj[deviceName + '/Ua'])
			let ub = isNaN(Number.parseFloat(state.MQTTObj[deviceName + '/Ub'])) ? 0 : Number.parseFloat(state.MQTTObj[deviceName + '/Ub'])
			let uc = isNaN(Number.parseFloat(state.MQTTObj[deviceName + '/Uc'])) ? 0 : Number.parseFloat(state.MQTTObj[deviceName + '/Uc'])

			if (ua == 0 && ub == 0 && uc == 0)
				return undefined

			let average = (ua + ub + uc) / 3
			let max = Math.max(ua, ub, uc)
			let min = Math.min(ua, ub, uc)

			return average === 0 ? 0 : ((max - min) * 100 / average).toFixed(2).replace(/[.]?0+$/, "")
		},

		getRooms: state => id => {
			if (state.surveillance.length > 0) {
				if (id == -1) {
					let rooms = {
						types: ["监控列表", "门禁列表"],
						details: [
							[],
							[],
						],
					}
					state.surveillance.forEach((item, index) => {
						if (item.rooms.details[0].length > 0)
							rooms.details[0].push(...item.rooms.details[0])
					})
					return rooms
				} else {
					return state.surveillance.find(item => item.areaId == id).rooms 
				}
			}
		},

		getThreeUrl: state => id => {
			if (state.allThreeUrl.length > 0) {
				let threeUrl = state.allThreeUrl.find(item => item.areaId == id).modelParams.split('/')
				let len = threeUrl.length
				return threeUrl[len - 1]
			} else {
				return ''
			}
		},

		getTotal_p: state => () => {
			let arr = []
			state.loopMaster.forEach((item, index) => {
				arr[index] = state.MQTTObj[item.subLoopUrl + '/P'] ? Number(state.MQTTObj[item.subLoopUrl + '/P']) : 0
			})
			return (arr.reduce((prev, next, index, array) => prev + next)) / 1000
		},
		
		
	},
	actions: {
		// 通过项目id获取当前项目所有区域
		// async actionsAllAreas(context){
		// 	// console.log(context);
		// 	let res = await GetAllAreas({projectId:context.state.projectId})
		// 	let areas = res.data.data.areas
		// 	context.commit('getAreas',areas)
		// }
	},
	modules:{
		Cang:Cang
	}
})